<cm-text appearance="emphasis" slot="header"
  >Listing internal clients for org {{ orgUuid }}</cm-text
>
<external-internal-client
  *ngFor="let clusterId of clusterIds"
  [orgUuid]="orgUuid"
  [clusterUuid]="clusterId"
>
</external-internal-client>
